<script lang="ts">
	//Design system components
	import { Text, Container } from '@Shelly/shelly-design-system';
	//Components
	import DayPicker from '../../../../components/TimePicker/DayPicker.svelte';
	//Services
	import { format } from 'svelte-i18n';
	//Svelte hooks
	import { createEventDispatcher, getContext } from 'svelte';

	const scheduleStore: SvelteStore<any> = getContext('schedule');
	const dispatch = createEventDispatcher();
	let days = $scheduleStore.days;
	const changeDays = (e) => {
		days = e.detail;
		dispatch('update', { days });
	};
</script>

<Container padding="scrollPaddings">
	<Text class="mb-s" element="h2">{$format('choose_weekday')}</Text>
	<DayPicker {days} on:change={changeDays} />
</Container>
